import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import type { Position } from '../../data/careers';
import { INTERNSHIP_TERMS } from '../../data/careers';
export function PositionCard({
  position
}: {
  position: Position;
}) {
  return <article className="group relative flex h-full flex-col rounded-md border border-line bg-panel p-6 transition-colors duration-200 hover:border-gold/70" data-id="element-689" data-mp="3t4qq2wrvhggw">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-690" data-mp="2wgkt8w16zsd6">{position.team}</p>
      <h3 className="mt-3 font-display text-[20px] leading-snug text-ink sm:text-[24px]" data-id="element-691" data-mp="30gl98l3xwbmc">
        <Link to={`/careers/${position.slug}`} className="after:absolute after:inset-0 after:rounded-md focus-visible:outline-none focus-visible:after:ring-2 focus-visible:after:ring-gold" data-id="element-692" data-mp="35e3hsae1oott">
          {position.title}
        </Link>
      </h3>
      <p className="mt-3 text-[15px] leading-relaxed text-body" data-id="element-693" data-mp="2hosdiixhkcax">{position.summary}</p>
      <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-6" data-id="element-694" data-mp="1mktp7wyk4lg4">
        <p className="flex items-center gap-1.5 text-small text-muted" data-id="element-695" data-mp="1iiyjmg9lflwj">
          <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-696" data-mp="1il2p32n54syx" />
          {position.location} · {INTERNSHIP_TERMS.duration}
        </p>
        <span className="inline-flex items-center gap-1.5 text-[15px] font-medium text-royal" data-id="element-697" data-mp="18tou9864whc4">
          View role
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-698" data-mp="13uviplaer0el" />
        </span>
      </div>
    </article>;
}